import React from 'react'
import PropTypes from 'prop-types'
import {Bug} from './types';
import './ProjectDetails.css';

function ProjectDetails({project, name}: any) {
    console.log('Project', project)
    const totalCount: number = project["Total"];
    const rootCauseInfo = project.RootCause;
    const manifestationInfo = project.Manifestation;
    const fixInfo = project.Fix;
    const projectBugs: Bug[] = project.Bugs;

    const rootCauseElem = <ul>
        {Object.keys(rootCauseInfo)
        .filter((rootCause) => {
            return rootCauseInfo[rootCause] !== 0;
        })
        .map((rootCause) => {
            const rootCauseCount = rootCauseInfo[rootCause];
            
            return <li>{rootCause}:&nbsp;{rootCauseCount}</li>
        })}
    </ul>;

    const manifestationElem = <ul>
        {Object.keys(manifestationInfo)
        .filter((manifestiation) => {
            return manifestationInfo[manifestiation] !== 0;
        })
        .map((manifestiation) => {
            const manifestiationCount = manifestationInfo[manifestiation];
            
            return <li>{manifestiation}:&nbsp;{manifestiationCount}</li>
        })}
        </ul>;

    const fixElem = <ul>
    {Object.keys(fixInfo)
    .filter((fix) => {
        return fixInfo[fix] !== 0;
    })
    .map((fix) => {
        const fixCount = fixInfo[fix];
        
        return <li>{fix}:&nbsp;{fixCount}</li>
    })}
    </ul>

    return (
        <div>
            <span><b><a href={`https://github.com/${name}`} rel="noreferrer" target="_blank">{name}</a></b></span><br/><br/>
            <span>Number of Bugs:&nbsp;{totalCount}</span>
            <br/>
            <br/>
            <div className="triple-group-parent">
                <div className="triple-group-child">
                    <b>Root Causes</b>
                    <br/>
                        {rootCauseElem}
                </div>
                <div className="triple-group-child">
                    <b>Manifestation Strategies</b>
                    <br/>
                    {manifestationElem}
                </div>
                <div className="triple-group-child">
                    <b>Buf Fix Strategies</b>
                    <br/>
                    {fixElem}
                </div>
            </div>
            <span><b>Bug List</b></span>
            <ul>
                {projectBugs.map(projectDetails => {
                    const {URL, Title, RootCause, Manifestation, Fix} = projectDetails
                    return <span key={`title-${URL}`}>
                        <a href={URL} rel="noreferrer" target="_blank">
                        {`${Title.substring(0,30)}... - ${RootCause} - ${Manifestation} - ${Fix}`}
                        </a>
                        <br/>
                        </span>
                })}
            </ul>
            <br/>
        </div>
    )
}

ProjectDetails.propTypes = {
    project: PropTypes.any,
    name: PropTypes.string
}

export default ProjectDetails

